import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the FilterPartnersProductsView.
 * @extends JetView
 */
export default class FilterPartnersProductsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            labelPosition: 'top',
                            label: _('Descripción'), // Description label
                            placeholder: _('Descripción'), // Placeholder for description
                            name: 'Description', // Name of the input field
                        },
                        {
                            view: 'text',
                            labelPosition: 'top',
                            label: _('Slug'), // Slug label
                            placeholder: _('Slug'), // Placeholder for slug
                            name: 'Slug', // Name of the input field
                        },
                        {
                            view: 'richselect',
                            name: 'Country', // Name of the select field
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Country label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for country selection
                            options: [], // Options will be populated dynamically
                            id: 'Countries', // ID for the country select
                            on: {
                                onChange: function (data, obj) {
                                    var currentValue = this.getValue(); // Get current value of the select
                                    if (currentValue.length > 0) {
                                        $$('button').enable(); // Enable button if a country is selected
                                    } else {
                                        $$('button').disable(); // Disable button if no country is selected
                                    }
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'State', // Name of the state select field
                            label: _('Estado'), // State label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for state selection
                            options: [
                                { id: '0', value: _('Activa') }, // Active state option
                                { id: '1', value: _('Inactiva') }, // Inactive state option
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'combo',
                            labelPosition: 'top',
                            label: _('Tipo'), // Type label
                            placeholder: _('Click para seleccionar '), // Placeholder for type selection
                            name: 'Type', // Name of the type field
                            options: [
                                { id: '0', value: _('Casino') }, // Casino type option
                                { id: '1', value: _('Live Casino') }, // Live Casino type option
                                { id: '2', value: _('Virtuales') }, // Virtual type option
                                { id: '3', value: _('Mini Games') }, // Mini Games type option
                                { id: '5', value: _('Bingo') }, // Bingo type option
                            ],
                        },
                        { gravity: 3 }, // Gravity for layout adjustment
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0, // Responsive height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include left section in the upper section
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 3 }, // Gravity for layout adjustment
                        {
                            view: 'button',
                            value: _('Agregar'), // Add button label
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Responsive width
                            minWidth: 200,
                            click: () => {
                                this.app.callEvent('add:button', [{}]); // Trigger add button event
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button label
                            width: screen == 'small' ? 0 : 100, // Responsive width
                            minWidth: 200,
                            click: () => {
                                $$('myForm').setValues(
                                    // Clear form values
                                    $$('myForm').getCleanValues(),
                                );
                                $$('CountrySelect').setValue(
                                    // Reset country selection
                                    $$('myForm').getCleanValues().CountrySelect,
                                );
                            },
                        },
                        {
                            view: 'button',
                            id: 'button',
                            disabled: true, // Initially disabled
                            value: _('Consultar'), // Consult button label
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Responsive width
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                filterdata.Partner = id_partner; // Add partner ID to filter data
                                this.app.callEvent('partnerCategories:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                                $$('b1').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true, // Initially collapsed
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Filters section header
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form',
            id: 'myForm', // Form ID
            type: 'clean',
            rows: [accordion_section1], // Include accordion section in the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and populates country options based on the selected partner.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const partners = profile.Partners; // Get partners from profile

        /**
         * Filters partners based on the partner ID.
         * @param {Object} partners - The partner object to filter.
         * @returns {boolean} True if the partner ID matches.
         */
        function filter_partners(partners) {
            return partners.id == id_partner; // Check if partner ID matches
        }

        var partner = partners.filter(filter_partners); // Filter partners
        var listCountries = partner[0].Countries.filter(
            // Filter countries for the selected partner
            (item) => item.value != 'Todos' && item.value != 'Default',
        );
        $$('Countries').define('options', listCountries); // Define options for country select
        $$('Countries').refresh(); // Refresh the country select
    }
}

// FILE DOCUMENTED
